import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

const mediaOutboundEndSessionTrue = {
  json: {
    menu: {
      menuType: 'media',
      input: {
        varName: '',
      },
      text: '',
      'media-direction': 'outbound',
      menuParams: {
        filename: '',
        endSession: true,
        varType: 'API',
      },
    },
    type: 'menu',
    metadata: {}
  },
  paths: [
    'menu.input.varName',
    'menu.text',
    'menu.media-direction',
    'menu.menuParams.filename',
    'menu.menuParams.varType',
    'menu.menuParams.endSession',
  ],
  groups: [
    {
      Parameters: [
        'menu.media-direction',
        'menu.input.varName',
        'menu.text',
        'menu.menuParams.filename',
        'menu.menuParams.varType',
        'menu.menuParams.endSession',
      ]
    },
  ],
};

const mediaOutboundEndSessionFalse = {
  json: {
    menu: {
      menuType: 'media',
      input: {
        varName: '',
      },
      text: '',
      'media-direction': 'outbound',
      menuParams: {
        filename: '',
        endSession: false,
        varType: 'API',
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.input.varName',
    'menu.text',
    'menu.media-direction',
    'menu.menuParams.filename',
    'menu.menuParams.varType',
    'menu.menuParams.endSession',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.input.varName',
        'menu.text',
        'menu.media-direction',
        'menu.menuParams.filename',
        'menu.menuParams.varType',
        'menu.menuParams.endSession',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
};

const mediaInbound = {
  json: {
    menu: {
      menuType: 'media',
      text: '',
      input: {
        varName: '',
      },
      'media-direction': 'inbound',
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: ['menu.input.varName', 'menu.text', 'menu.media-direction', 'next'],
  groups: [
    {
      Parameters: ['menu.media-direction', 'menu.input.varName', 'menu.text'],
    },
    {
      Logic: ['next'],
    },
  ],
};

export const media = {
  json: {
    menu: {
      menuType: 'media',
      text: '',
      input: {
        varName: '',
      },
      menuParams: {
        endSession: true,
      },
      'media-direction': 'inbound',
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: ['menu.input.varName', 'menu.text', 'menu.media-direction', 'next'],
  groups: [
    {
      Parameters: ['menu.media-direction', 'menu.input.varName', 'menu.text'],
    },
    {
      Logic: ['next'],
    },
  ],
  layout: {
    text: {
      type: 'text',
      label: 'Caption (Optional)',
      validators: {
        required: false,
      },
      attributes: {
        labels: {
          path: 'menu.media-direction',
          values: {
            outbound: 'Caption (Optional)',
            inbound: 'Text',
          },
        },
        types: {
          path: 'menu.media-direction',
          values: {
            outbound: 'text',
            inbound: 'textarea',
          },
        },
      },
    },
    varName: {
      type: 'asset',
      label: '',
      validators: {
        required: true,
      },
      attributes: {
        buttons: [
          {
            text: 'API',
            value: 'API',
          },
          {
            text: 'Assets',
            value: 'Assets',
          },
        ],
      },
    },
    filename: {
      type: 'text',
      label: 'File Name override (Optional)',
      validators: {
        required: false,
      },
    },
    'media-direction': {
      type: 'selector',
      label: 'Media Direction',

      attributes: {
        options: {
          inbound: 'Inbound',
          outbound: 'Outbound',
        },
        data: true,
      },
      validators: {
        required: true,
        optionSelected: true,
      },
    },
    endSession: {
      type: 'checkbox-single',
      label: 'End Session',
      attributes: {
        options: {
          true: 'true',
          false: 'false',
        },
        data: true,
      },
    },
    varType: {
      type: 'hidden',
      label: '',
    },
    next: {
      type: 'next',
      label: 'Point to',
    },
  },
  data: {
    'media-direction': {
      inbound: mediaInbound,
      outbound: mediaOutboundEndSessionTrue,
    },
    endSession: {
      true: mediaOutboundEndSessionTrue,
      false: mediaOutboundEndSessionFalse,
    },
    dataPath: ['menu.media-direction', 'menu.menuParams.endSession'],
  },
};
